import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faFilter } from "@fortawesome/free-solid-svg-icons";
import { ToastContainer } from "react-toastify";
import useAdminWhatsapp from "../../services/Admin/useAdminWhatsapp";


const AdminWhatsApp = ({ Admin }) => {
  const {
    filteredClients,
    loading,
    searchTerm,
    activeTab,
    setActiveTab,
    handleSearch,
    viewCampaign,
    viewTemplates,
  } = useAdminWhatsapp({ Admin });

  const ClientCard = ({ client, type }) => {
    const items =
      type === "campaigns"
        ? client?.campaigns || []
        : client?.templates || [];

    const handleClick = () => {
      if (type === "campaigns") {
        viewCampaign(client.us_code);
      } else {
        viewTemplates(client.us_code);
      }
    };

    return (
      <div
        onClick={handleClick}
        className="h-full w-full cursor-pointer rounded-lg border border-gray-200 bg-white shadow-none transition hover:-translate-y-[2px] hover:shadow-md"
      >
        <div className="p-5">
          <div className="mb-4 border-l-4 border-green-600 pl-4">
            <h3 className="mb-1 text-[18px] font-semibold text-gray-900">
              {client?.us_name || client?.name || "Client Name"}
            </h3>

            <p className="text-[14px] text-gray-500">
              Code: {client?.us_code || client?.code || "-"}
            </p>
          </div>

          <div className="rounded-lg bg-gray-50 p-4">
            <h6 className="mb-3 text-[15px] font-semibold text-blue-600">
              {type === "campaigns"
                ? "Total Campaigns"
                : "Available Templates"}
            </h6>

            {items.length > 0 ? (
              <ul className="space-y-2">
                {items.map((item, index) => (
                  <li
                    key={index}
                    className="flex items-center rounded-md bg-white p-2 text-[14px] text-gray-700"
                  >
                    <span className="mr-2 inline-block h-2 w-2 rounded-full bg-green-600" />
                    {item}
                  </li>
                ))}
              </ul>
            ) : (
              <p className="rounded-md bg-white p-2 text-[14px] text-gray-400">
                No data available
              </p>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-white p-4">
      <ToastContainer />

      {/* Search + Filter */}
      <div className="mb-6">
        <div className="flex flex-col gap-3 md:flex-row md:items-center">
          <div className="relative flex-1">
            <FontAwesomeIcon
              icon={faSearch}
              className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
            />

            <input
              type="text"
              placeholder="Search clients by name or code..."
              value={searchTerm}
              onChange={(e) => handleSearch(e.target.value)}
              className="h-[42px] w-full rounded-md border border-gray-300 bg-white pl-10 pr-4 text-[15px] font-medium text-gray-800 outline-none transition placeholder:font-normal placeholder:text-gray-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
            />
          </div>

          <button
            type="button"
            className="flex h-[42px] items-center justify-center gap-2 rounded-md border border-gray-300 bg-white px-4 text-[15px] font-medium text-gray-700 transition hover:bg-gray-50"
          >
            <FontAwesomeIcon icon={faFilter} />
            Filter
          </button>
        </div>
      </div>

      {/* Tabs */}
      <div className="mb-6 border-b border-gray-200">
        <div className="flex gap-2">
          <button
            type="button"
            onClick={() => setActiveTab("campaigns")}
            className={`border-b-2 px-4 py-3 text-[15px] font-semibold transition ${
              activeTab === "campaigns"
                ? "border-blue-600 text-blue-600"
                : "border-transparent text-gray-500 hover:text-blue-600"
            }`}
          >
            Campaigns
          </button>

          <button
            type="button"
            onClick={() => setActiveTab("templates")}
            className={`border-b-2 px-4 py-3 text-[15px] font-semibold transition ${
              activeTab === "templates"
                ? "border-blue-600 text-blue-600"
                : "border-transparent text-gray-500 hover:text-blue-600"
            }`}
          >
            Templates
          </button>
        </div>
      </div>

      {/* Content */}
      {loading ? (
        <div className="flex min-h-[250px] items-center justify-center">
          <p className="text-[15px] font-semibold text-gray-500">
            Loading clients...
          </p>
        </div>
      ) : filteredClients.length > 0 ? (
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-3">
          {filteredClients.map((client, index) => (
            <ClientCard
              key={client?.id || client?.us_code || index}
              client={client}
              type={activeTab}
            />
          ))}
        </div>
      ) : (
        <div className="flex min-h-[250px] items-center justify-center rounded-lg border border-dashed border-gray-300 bg-gray-50">
          <p className="text-[15px] font-semibold text-gray-500">
            No clients found
          </p>
        </div>
      )}
    </div>
  );
};

export default AdminWhatsApp;